module.exports = __webpack_public_path__ + "img/nodejs.f5807165.svg";